import type { BookingStatus } from '@navio/nsdk';
import { type FilterOption } from 'noddi-ui-web';
import { BOOKING_STATUS_OPTIONS_BACKOFFICE } from 'noddi-util';
import { BOOKING_STATUS_ICON } from '../../../features/Booking/BookingStatusIcon';

/** Back-office booking statuses, with their status icons. */
export const BOOKING_STATUS_FILTER_OPTIONS: FilterOption<BookingStatus>[] = BOOKING_STATUS_OPTIONS_BACKOFFICE.map(
  (option) => ({ ...option, icon: BOOKING_STATUS_ICON[option.value] })
);
